import React, { Component } from "react"
import { Link } from "react-router-dom"

class NavItem extends Component {
    constructor(props) {
        super(props)
        this.state = { isHovering: false }
        this.onHover = this.onHover.bind(this)
        this.onHoverEnd = this.onHoverEnd.bind(this)
        this.onClick = this.onClick.bind(this)
    }

    onHover(event) {
        event.preventDefault()
        this.setState({ isHovering: true })
    }

    onHoverEnd(event) {
        event.preventDefault()
        this.setState({ isHovering: false })
    }

    onClick() {
        const { routeId, link } = this.props
        this.props.onClick(routeId, link)
    }

    render() {
        const { isActive, route } = this.props
        const iconStyles = {
            ...route.iconStyles,
            backgroundImage: `url(${
                isActive || this.state.isHovering
                    ? route.activeIcon
                    : route.icon
            })`
        }
        return (
            <li
                className={`nav-item ${isActive ? "active" : ""}`}
                onMouseOver={this.onHover}
                onMouseOut={this.onHoverEnd}
                onClick={this.onClick}
            >
                <Link to={route.link} className="nav-link">
                    {(route.activeIcon || route.icon) && (
                        <i style={iconStyles} />
                    )}
                    {route.label}
                </Link>
            </li>
        )
    }
}

export default NavItem
